import { render, staticRenderFns } from "./EditVulnerability.vue?vue&type=template&id=61adeba7"
import script from "./EditVulnerability.vue?vue&type=script&lang=js"
export * from "./EditVulnerability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports